import { useCallback } from 'react';
import useAjax from '@apis/useAjax';
import { POST_CLUB_EXCEPTION_ORDER_API } from '@apis/apiPath';

/**
 * 店鋪異常單相關 API Hook
 * 對應後端 ClubExceptionOrderController
 */
const useClubExceptionOrderApi = () => {
    const Ajax = useAjax();

    /**
     * 新增異常單
     * @param {object} params 異常單資訊 (ClubExceptionOrderRequestModel)
     *   - clubPurchaseReceiptID: number 進貨單代碼
     *   - purchaseDate: string 建單日期
     *   - employeeID: number 教練代碼
     *   - items: Array<{ productID, variantID, quantity(應驗收未入庫量) }>
     * @returns {Promise<{ exceptionOrderID: number|null, completedOrder: boolean }>} ClubExceptionOrderCompleteResponseModel
     */
    const postClubExceptionOrderApi = useCallback(
        async (params) => await Ajax.post(POST_CLUB_EXCEPTION_ORDER_API, params),
        // eslint-disable-next-line
        [],
    );

    return {
        postClubExceptionOrderApi,
    };
};

export default useClubExceptionOrderApi;
